export default {"src":"/_next/static/media/image-icon.9b8c0e4f.svg","height":513,"width":513};